import { RevisionFile } from "shared/types/revision";

export interface GalleryItem {
  id: string;
  src: string;
  name: string;
  alt: string;
  thumbnail?: string;
}

export interface Gallery {
  items: GalleryItem[];
  initialIndex: number;
}

export const buildGallery = (
  files: RevisionFile[],
  clickedFileId: string,
): Gallery | null => {
  const images = files.filter((file) => file.type === "image");
  const initialIndex = images.findIndex((file) => file.id === clickedFileId);
  if (initialIndex === -1) return null;

  return {
    items: images.map((file) => ({
      id: file.id,
      src: file.thumbnail || "",
      name: file.name,
      alt: file.name,
      thumbnail: file.thumbnail,
    })),
    initialIndex,
  };
};
